/* eslint-disable import/prefer-default-export */

import { COURSE_DETAILS__GET_COURSE, COURSE_DETAILS__GET_COURSE_SUCCESS, COURSE_DETAILS__GET_COURSE_FAIL, COURSE_DETAILS__RESET_COURSE, COURSE_DETAILS__GET_RELATED_COURSES, COURSE_DETAILS__GET_RELATED_COURSES_SUCCESS, COURSE_DETAILS__GET_RELATED_COURSES_FAIL, COURSE_DETAILS__GET_TEXT_NOTES, COURSE_DETAILS__GET_TEXT_NOTES_SUCCESS, COURSE_DETAILS__GET_TEXT_NOTES_FAIL, COURSE_DETAILS__GET_VIDEO_NOTES, COURSE_DETAILS__GET_VIDEO_NOTES_SUCCESS, COURSE_DETAILS__GET_VIDEO_NOTES_FAIL, COURSE_DETAILS__GET_PUBLIC_NOTES_STATE, COURSE_DETAILS__GET_PUBLIC_NOTES_STATE_FAIL, COURSE_DETAILS__GET_PUBLIC_NOTES_STATE_SUCCESS, COURSE_DETAILS__TOGGLE_LIVESTREAM_CHAT, COURSE_DETAILS__RESET_COURSE_PROGRESS } from '../constants';
import { buildQuery } from '../helpers';
export function getCourseBySlug(slug) {
  return {
    types: [COURSE_DETAILS__GET_COURSE, COURSE_DETAILS__GET_COURSE_SUCCESS, COURSE_DETAILS__GET_COURSE_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/courses/by-slug/".concat(slug), {
        method: 'GET'
      });
    }
  };
}
export function getRelatedCourses(courseId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    page: 1,
    perPage: 6
  };
  var query = buildQuery(params);
  return {
    types: [COURSE_DETAILS__GET_RELATED_COURSES, COURSE_DETAILS__GET_RELATED_COURSES_SUCCESS, COURSE_DETAILS__GET_RELATED_COURSES_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/courses/".concat(courseId, "/related?").concat(query), {
        method: 'GET'
      });
    }
  };
}
export function getCourseTextNotes(courseId) {
  return {
    types: [COURSE_DETAILS__GET_TEXT_NOTES, COURSE_DETAILS__GET_TEXT_NOTES_SUCCESS, COURSE_DETAILS__GET_TEXT_NOTES_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/courses/".concat(courseId, "/text-notes"), {
        method: 'GET'
      });
    }
  };
}
export function getCourseVideoNotes(courseId) {
  return {
    types: [COURSE_DETAILS__GET_VIDEO_NOTES, COURSE_DETAILS__GET_VIDEO_NOTES_SUCCESS, COURSE_DETAILS__GET_VIDEO_NOTES_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/courses/".concat(courseId, "/video-notes"), {
        method: 'GET'
      });
    }
  };
}
export function getCoursePublicNotesStatus(courseId) {
  return {
    types: [COURSE_DETAILS__GET_PUBLIC_NOTES_STATE, COURSE_DETAILS__GET_PUBLIC_NOTES_STATE_SUCCESS, COURSE_DETAILS__GET_PUBLIC_NOTES_STATE_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/courses/".concat(courseId, "/share-notes"), {
        method: 'GET'
      });
    }
  };
}
export function toggleChat() {
  return {
    type: COURSE_DETAILS__TOGGLE_LIVESTREAM_CHAT
  };
}
export function resetCourseProgress() {
  return {
    type: COURSE_DETAILS__RESET_COURSE_PROGRESS
  };
}
export function reset() {
  return {
    type: COURSE_DETAILS__RESET_COURSE
  };
}